export const CBackgroundDark = "hsl(219.6, 27%, 10%)";
export const CNavBackgroundDark = "hsl(219.6, 27%, 7%)";
export const CCardBackgroundDark = "hsl(219.6, 27%, 12%)";
export const CTableBackgroundDark = "hsl(219.6, 27%, 12%)";
export const CCtaBackgroundDark = "hsl(219.6, 27%, 13%)";
export const CBackgroundHslDark = "219.6, 27%, 10%";
export const CNavBackgroundHslDark = "219.6, 27%, 7%";
export const CCardBackgroundHslDark = "219.6, 27%, 12%";
export const CContentBackgroundHslDark = "219.6, 27%, 12%";
export const CTableBackgroundHslDark = "219.6, 27%, 12%";
export const CCtaBackgroundHslDark = "219.6, 27%, 13%";
export const CBorderBaseDark = "hsl(219.6, 27%, 20%)";
export const CBorderWeakDark = "hsl(219.6, 27%, 8%)";
export const CBorderStrongDark = "hsl(219.6, 27%, 28%)";
export const CCodeTextDark = "hsl(219.6, 27%, 96%)";
export const CCodeBorderDark = "hsl(219.6, 27%, 25%)";
export const CCodeBackgroundDark = "hsl(219.6, 27%, 20%)";
export const CCtaDefaultHslDark = "183.3, 100%, 49.6%";
export const CCtaDefaultDark = "hsl(183.3, 100%, 49.6%)";
export const CCtaDefaultTransparentDark = "hsla(183.3, 100%, 49.6%, 0)";
export const CCtaDefaultMinorDark = "hsla(183.3, 100%, 49.6%, 0.15)";
export const CCtaDefaultWeakDark = "hsla(183.3, 100%, 49.6%, 0.3)";
export const CCtaDefaultMediumDark = "hsla(183.3, 100%, 49.6%, 0.5)";
export const CCtaDefaultHeavyDark = "hsla(183.3, 100%, 49.6%, 0.7)";
export const CCtaDefaultMajorDark = "hsla(183.3, 100%, 49.6%, 0.85)";
export const CCtaDefaultOpaqueDark = "hsla(183.3, 100%, 49.6%, 1)";
export const CCtaSuccessHslDark = "150.8, 100%, 50%";
export const CCtaSuccessDark = "hsl(150.8, 100%, 50%)";
export const CCtaSuccessTransparentDark = "hsla(150.8, 100%, 50%, 0)";
export const CCtaSuccessMinorDark = "hsla(150.8, 100%, 50%, 0.15)";
export const CCtaSuccessWeakDark = "hsla(150.8, 100%, 50%, 0.3)";
export const CCtaSuccessMediumDark = "hsla(150.8, 100%, 50%, 0.5)";
export const CCtaSuccessHeavyDark = "hsla(150.8, 100%, 50%, 0.7)";
export const CCtaSuccessMajorDark = "hsla(150.8, 100%, 50%, 0.85)";
export const CCtaSuccessOpaqueDark = "hsla(150.8, 100%, 50%, 1)";
export const CInputDisabledDark = "hsl(219.6, 27%, 7%)";
export const CShadowDark = "hsla(219.6, 27%, 4%, 0.3)";
export const CShadowNavDark = "hsla(219.6, 27%, 50%, 0.15)";
export const CTableRowHighlightedDark = "hsl(219.6, 27%, 5%)";
export const CTableRowEvenDark = "hsl(219.6, 27%, 11%)";
export const CTextDark = "hsl(219.6, 27%, 99%)";
export const CTextSecondaryDark = "hsl(219.6, 27%, 90%)";
export const CTextOnOppositeBackgroundDark = "hsl(219.6, 27%, 2%)";
export const HueSatDark = "219.6, 27%";